export const CHAT_REACTIONS = ['like', 'fine', 'dislike'] as const;
export type ChatReaction = typeof CHAT_REACTIONS[number];
export const CHAT_REACTION_LABELS: Record<ChatReaction, string> = {
  like: 'Like', fine: "It's fine", dislike: 'Dislike',
};

export function readChatReaction(context: unknown): ChatReaction | null {
  const value = context && typeof context === 'object' ? (context as Record<string, unknown>).reaction : null;
  return CHAT_REACTIONS.includes(value as ChatReaction) ? value as ChatReaction : null;
}

export type ChatSurveyEvent = {
  id: string;
  rating: number | null;
  reaction: ChatReaction | null;
  skipped: boolean;
  feedbackText: string | null;
  lastMessageId: string | null;
  createdAt: string;
};

export function surveyMessageId(
  survey: Pick<ChatSurveyEvent, 'lastMessageId' | 'createdAt'>,
  messages: Array<{ id: string; createdAt: string }>,
): string | null {
  // Explicit references must never move onto a different conversation branch.
  if (survey.lastMessageId) return survey.lastMessageId;
  const submittedAt = Date.parse(survey.createdAt);
  let preceding: { id: string; time: number } | null = null;
  for (const message of messages) {
    const time = Date.parse(message.createdAt);
    if (time <= submittedAt && (!preceding || time >= preceding.time)) preceding = { id: message.id, time };
  }
  return preceding?.id ?? null;
}

/** Puts star ratings on the reaction scale: 4–5 stars Like, 3 It's fine, 1–2 Dislike. */
export function surveySentiment(
  survey: Pick<ChatSurveyEvent, 'rating' | 'reaction' | 'skipped'>,
): ChatReaction | null {
  if (survey.skipped) return null;
  if (survey.reaction) return survey.reaction;
  if (survey.rating == null) return null;
  return survey.rating >= 4 ? 'like' : survey.rating === 3 ? 'fine' : 'dislike';
}
